import { createAction } from '@reduxjs/toolkit'

export const fetchSettings = createAction('fetchSettings')

export const getSettings = data => dispatch => {
  dispatch(fetchSettings(data))
}
